<form [formGroup]="Form" (submit)="onSubmit()" class="mb-6">
  <div class="input-group">
    <input
      type="text"
      (change)="onSubmit()"
      formControlName="q"
      class="form-control form-control-lg"
      placeholder="Поиск сообще1111ний или пользователей..."
    />
    <div class="input-group-append">
      <button class="btn btn-lg btn-ico btn-secondary btn-minimal" type="submit">
        <i class="fe-search"></i>
      </button>
    </div>
  </div>
</form>
